export enum TwoFactorMethod {
  Totp = 'totp',
  Email = 'email'
}
